<nav class="bottom-menu" aria-label="Quick links">
  <button
    type="button"
    *ngFor="let item of bottomMenu"
    class="bottom-menu__item"
    [class.is-active]="component === item.Redirection"
    (click)="openUrl(item)"
  >
    <span class="bottom-menu__icon">
      <img [src]="item.Image" alt="" width="22" height="22" decoding="async" />
    </span>
    <span class="bottom-menu__label">{{ item.Title }}</span>
  </button>
</nav>
